<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" width="500">
      <template v-slot:activator="{ on }">
        <v-btn color="primary" flat small v-on="on" style="min-width:0">
          <v-icon>help_outline</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>{{question.body}}</v-card-title>
        <v-card-text style="white-space:pre-wrap;">{{question.description}}</v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" flat @click="dialog = false">Dismiss</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "Description",
  props: {
    question: null
  },
  data() {
    return { dialog: false };
  }
};
</script>